import { gql } from 'graphql-request';

export const aiAssistantPrompt = gql`
  mutation SendWA_QueryToAIAssistant($query: String!, $appTimezoneOffset: String!) {
    wawiAssist {
      sendWA_QueryToAIAssistant(query: $query, appTimezoneOffset: $appTimezoneOffset)
    }
  }
`;
export const aiAssistantResponse = gql`
  query GetWA_ReplyFromAIAssistant($jobId: String!) {
    wawiAssist {
      getWA_ReplyFromAIAssistant(jobId: $jobId) {
        status
        reply {
          role
          content {
            text
            files {
              path
              file_format
            }
            expert_mode {
              total_steps_count
              total_time_spent_sec
              steps {
                number
                name
                details {
                  type
                  model
                  status
                  time_spent_sec
                  total_tokens_spent
                  arguments {
                    code
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
